import { OPERATOR_PREFIXES } from "../utils/msisdn";

export { OPERATOR_PREFIXES };

export const OTP_LENGTH = {
  ZAIN: 5,
  KOREK: 4,
};

/** Korek OTPs are 4 digits; Zain (and any unresolved operator) is 5. */
export function getOtpLengthForOperator(operator) {
  return operator === "KOREK" ? OTP_LENGTH.KOREK : OTP_LENGTH.ZAIN;
}

// ChannelID value used by Korek header pages to validate callback params.
export const CHANNEL_ID_HEADER_FLOW = "99944036";
